import React, { useState, useContext } from 'react';
import styled from 'styled-components'
import Input from '../../../../../components/input'
import Button from '../../../../../components/button'
import ProfileIcon from '@material-ui/icons/Https';
import { AuthContext } from '../../../../../auth-context'
import { setPassword } from '../../../../../api'
import { DashboardContext } from '../../../dashboard-context'
import { ErrorMessage } from '../../../../../components/error-message';
const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`;

const Label = styled.label`
  color: #555;
  display: flex;
  align-items: center;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
  margin-bottom: 24px;

  svg {
    fill: #555;
    height: auto;
    width: 36px;
    margin-right: 16px;
  }

  @media(max-width: 900px) {
    font-size: 1.25rem;
    margin-bottom: 16px;

    svg {
      width: 28px;
    }
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;

  @media(max-width: 900px) {
    margin-top: 16px;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  margin-left: 16px;
  min-width: 180px;
`;

const ChangePassword = (props) => {
  const { openSnackbar } = useContext(DashboardContext);
  const { user } = useContext(AuthContext);
  const [password, updatePassword] = useState('')
  const [confirmPassword, updateConfirmPassword] = useState('')
  const [passwordError, updatePasswordError] = useState(false)
  const [passwordErrorMessage, updateErrorMessage] = useState('')


  const validatePassword = () => {
    if(password !== confirmPassword) {
      updateErrorMessage('Passwords do not match.')
      updatePasswordError(true)
      return false;
    } else if(password.length < 8) {
      updateErrorMessage('Password must be at least 8 characters.')
      updatePasswordError(true)
      return false;
    } else if(!(/(?=.*[a-z]+)/.test(password))) {
      updateErrorMessage('Password must have at least one uppercase and one lowercase letter.')
      updatePasswordError(true)
      return false;
    } else if(!(/(?=.*[A-Z]+)/.test(password))) {
      updateErrorMessage('Password must have at least one uppercase and one lowercase letter.')
      updatePasswordError(true)
      return false;
    } else if(!(/(?=.*\d+)/.test(password))) {
      updateErrorMessage('Password must have at least one number.')
      updatePasswordError(true)
      return false;
    }

    return true;
  }

  const submitPassword = () => {
    if (validatePassword()) {
      setPassword(user.id, password).then((res) => {
        openSnackbar('Edited password successfully!', false)
        updatePasswordError(false);
      }).catch((err) => {
        openSnackbar('There was a problem changing your password.', true)
      })
    }
  }

  return (
    <React.Fragment>
      <Container className={props.className}>
        <Label>
          <ProfileIcon /> Change Password
        </Label>
        <Input
          error={passwordError}
          label="New Password"
          type='password'
          autoComplete="current-password" 
          value={password}
          onChange={updatePassword}
        />
        <Input
          error={passwordError}
          label="Confirm Password"
          type='password'
          autoComplete="current-password"
          value={confirmPassword}
          onChange={updateConfirmPassword}
        />
        {passwordError &&
          <ErrorMessage>
           {passwordErrorMessage}
          </ErrorMessage>
        }
        <ButtonContainer>
          <AddButton 
            label="Update password"
            onClick={submitPassword}
          />
        </ButtonContainer>
      </Container>
  </React.Fragment>
  )
}

export default ChangePassword